module.exports = __webpack_public_path__ + "img/流程.c24514ba.png";